
export default function holiday( state = [], action = {} ){

	switch( action.type ){
		case 'GET_COMPANY_HOLIDAY':
			return action.holiday
		case 'SAVE_HOLIDAY':
			return action.holiday
		case 'GET_HOLIDAYS':
			return action.holiday
		case 'DELETE_HOLIDAY':
			return action.holiday
		case 'GET_USERS_HOLIDAY':
			return action.holiday
		default: return state;
	}
		
}




// WEBPACK FOOTER //
// ./src/store/reducers/holiday/holiday.reducer.js